"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_MODIFIERS_KEY = void 0;

/* eslint-disable import/prefer-default-export */
var DEFAULT_MODIFIERS_KEY = '_';
exports.DEFAULT_MODIFIERS_KEY = DEFAULT_MODIFIERS_KEY;